import type { MargensPraticadoPerdeuLinha } from '@triade/contracts';
import { formatarFracaoPercentual } from '@/lib/format';
import type { BuscaMargens } from '../tipos';

/**
 * Blocos de custo atualizado do painel de margens. A API ordena com direcao FIXA por opcao (nao ha `direcao` na consulta),
 * entao a tela so troca o campo e mostra a seta da direcao que a API usa. Filtros: periodo (e a data que ele filtra), tabela e tipo (sem status e origem).
 */
export const DIRECAO_PROPOSTAS = { queda: 'desc', numero: 'desc', validade: 'asc' } as const;
export const DIRECAO_PRATICADOS = { delta: 'desc', codigo: 'asc', desde: 'desc' } as const;

export function consultaCusto(b: BuscaMargens): Record<string, string> {
  return {
    ...(b.dataDe ? { dataDe: b.dataDe } : {}),
    ...(b.dataAte ? { dataAte: b.dataAte } : {}),
    ...(b.tabelaId ? { tabelaId: b.tabelaId } : {}),
    ...(b.tipo ? { tipo: b.tipo } : {}),
    ...(b.dataRef ? { dataRef: b.dataRef } : {}),
  };
}

export const ROTULO_ORIGEM_MARCA: Record<MargensPraticadoPerdeuLinha['origem'], string> = {
  LOTE: 'Lote de custo',
  FICHA_ESCOLHIDA: 'Ficha escolhida',
};

/** Faixa do lucro de hoje a partir das flags que a API manda (abaixoDoMinimo, abaixoDaMeta). Nada e comparado aqui. */
export function faixaPraticado(l: Pick<MargensPraticadoPerdeuLinha, 'abaixoDaMeta' | 'abaixoDoMinimo'>): 'green' | 'orange' | 'red' | undefined {
  if (l.abaixoDoMinimo === true) return 'red';
  if (l.abaixoDaMeta === true) return 'orange';
  if (l.abaixoDaMeta === false) return 'green';
  return undefined;
}

/** Fracao da API com sinal explicito quando positiva ("+9,25%"). So formatacao. */
export function percentualComSinal(fracao: string): string {
  const t = formatarFracaoPercentual(fracao);
  return fracao.trim().startsWith('-') ? t : `+${t}`;
}
